import {handleActions} from 'redux-actions'
import {constants as kandyConstants} from 'kandy-redux'

const reducers = {}
reducers[kandyConstants.SEND_MESSAGE_FINISH] = {
	next (state, action) {
		return {}
	},
	throw () {
		return {sendMessageError: true}
	}
}

export default handleActions(reducers, {})
